<template>
    <div>
        <Selection
            :selection="selection"
            :error="error"
            :key="selection.getEventId()"
            :broadcasts="broadcasts"
            :oddValueDynamics="oddValueDynamics"
            @removeClick="onRemoveClick"
        >
            <input
                v-model="isFixed"
                :id="selection.getEventId().toString()"
                type="checkbox"
                class="selection-row__fix-switch-checkbox"
            >
            <label
                :for="selection.getEventId().toString()"
                class="selection-row__fix-switch-label"
            >
                FIX
            </label>
        </Selection>
    </div>
</template>

<script>
    import Selection from '@shared/betSlip/Selection.vue';

    export default {
        name: 'SystemBetSlipItem',
        props: {
            selection: {
                type: Object,
                required: true
            },
            error: {
                type: Object,
                required: false,
            },
            broadcasts: {
                type: Object,
                required: true
            },
            oddValueDynamics: {
                type: Object,
                required: false,
            },
        },
        computed: {
            isFixed: {
                get() {
                    return this.selection.isFixed;
                },
                set() {
                    this.$emit('fixClick', this.selection);
                }
            }
        },
        methods: {
            onRemoveClick(selection) {
                this.$emit('removeClick', selection);
            }
        },
        components: {
            Selection
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/shared/betSlip/SystemBetSlipItem.vue